import { useQuery } from 'react-query';
import { AxiosError } from 'axios';

import {
  fetchHsaBulkTransferInfo,
  FetchMemberHsaBulkTransferResponse,
} from 'apis/hsaBulkTransfer';

export type IMemberHsaBulkTransfer = FetchMemberHsaBulkTransferResponse;

const getHsaBulkTransfer = async () => {
  try {
    const { data } = await fetchHsaBulkTransferInfo();
    return { data };
  } catch (e) {
    // API returns a 400 if there is no HsaBulkTransfer information
    return null;
  }
};

/**
 * Used to retrieve hsa bulk transfer member decision
 */
const useQueryHsaBulkTransfer = ({
  enabled = false,
  onError,
}: {
  enabled: boolean;
  onError?: (e: AxiosError) => void;
}) => {
  const { data, isLoading, refetch } = useQuery(
    ['getHsaBulkTransfer'],
    () => getHsaBulkTransfer(),
    {
      enabled,
      onError,
    }
  );

  return { data, isLoading, refetch };
};

export default useQueryHsaBulkTransfer;
